module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review_packet"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("会员功能")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/main/memberredpacket'
      },
      "replace": ""
    }
  }, [_vm._v("会员红包")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("创建红包")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.data.act_type === 'type_common') ? _c('div', {
    staticClass: "review-info__wrapper"
  }, [_c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("红包类型")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.act_type_label))])])]), _vm._v(" "), (!_vm.role.single) ? _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("适用门店")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.shopNameList))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("通知会员数")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.member_total || 0))]), _vm._v("人")])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("单个红包金额")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.amt_max))]), _vm._v("元")])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("使用条件")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_vm._v("微信支付"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.data.limit_amt))]), _vm._v("元以上可用")])]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "review-info flex"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("通知时间")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc__wrapper"
  }, [_c('div', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.notify_time) + " 11:00:00")])]), _vm._v(" "), _c('div', {
    staticClass: "info-desc remark mt-20"
  }, [_vm._v("备注：红包费用由商户承担")])])])]) : _vm._e()]), _vm._v(" "), (_vm.data.act_type === 'type_payment') ? _c('div', {
    staticClass: "review-info__wrapper"
  }, [_c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("活动名称")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.act_name))])])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("红包类型")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.act_type_label))])])]), _vm._v(" "), (!_vm.role.single) ? _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("适用门店")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.shopNameList))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("活动开始时间")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.start_time))])])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("活动结束时间")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.expire_time))])])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("总预算")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.total_amt))]), _vm._v("元")])]), _vm._v(" "), (_vm.data.packetValue === 0) ? [_c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("单个红包金额")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.singleValue))]), _vm._v("元")])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("红包个数")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.coupon_num))]), _vm._v("个")])])] : _vm._e(), _vm._v(" "), (_vm.data.packetValue === 1) ? [_c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("单个红包金额")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.amt_min))]), _vm._v("至"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.data.amt_max))]), _vm._v("元")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "review-info flex"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("红包规则")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc__wrapper"
  }, [_c('div', {
    staticClass: "info-desc"
  }, [_vm._v("会员微信扫描收款码支付满"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.data.obtain_amt) + "元")]), _vm._v("可获得红包；")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc"
  }, [_vm._v("红包领取后"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.effectList[_vm.data.effect_offset]) + "，" + _vm._s(_vm.data.effect_date) + "天")]), _vm._v("内有效")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc"
  }, [_vm._v("会员有效期内微信扫收款码"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.data.limit_amt) + "元")]), _vm._v("以上可用")]), _vm._v(" "), _vm._m(2, false, false)])])], 2) : _vm._e(), _vm._v(" "), (_vm.data.act_type === 'type_sharing') ? _c('div', {
    staticClass: "review-info__wrapper"
  }, [_c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("活动名称")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.act_name))])])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("红包类型")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.act_type_label))])])]), _vm._v(" "), (!_vm.role.single) ? _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("适用门店")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.shopNameList))])])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("活动开始时间")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.start_time))])])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("活动结束时间")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.expire_time))])])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("总预算")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.total_amt))]), _vm._v("元")])]), _vm._v(" "), (_vm.data.packetValue === 0) ? [_c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("单个红包金额")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.singleValue))]), _vm._v("元")])]), _vm._v(" "), _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("红包个数")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.coupon_num))]), _vm._v("个")])])] : _vm._e(), _vm._v(" "), (_vm.data.packetValue === 1) ? [_c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("单个红包金额")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v(_vm._s(_vm.data.amt_min))]), _vm._v("至"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.data.amt_max))]), _vm._v("元")])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "review-info flex"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("红包规则")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc__wrapper"
  }, [_c('div', {
    staticClass: "info-desc"
  }, [_vm._v("会员微信扫描收款码支付满"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.data.obtain_amt) + "元")]), _vm._v("可获得红包；")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc"
  }, [_vm._v("每个分享链接可以有10人领取红包，每人只能领取一个；")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc"
  }, [_vm._v("红包领取后"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.effectList[_vm.data.effect_offset]) + "，" + _vm._s(_vm.data.effect_date) + "天")]), _vm._v("内有效")]), _vm._v(" "), _c('div', {
    staticClass: "info-desc"
  }, [_vm._v("会员有效期内微信扫收款码"), _c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.data.limit_amt) + "元")]), _vm._v("以上可用")]), _vm._v(" "), _vm._m(3, false, false)])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-submit_wrapper"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.backToEdit
    }
  }, [_vm._v("返回修改")]), _vm._v(" "), _c('div', {
    staticClass: "panel-btn__download panel-btn__download_detail",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.iconShow) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _c('i', {
    staticClass: "icon-create"
  }, [_c('span', [_vm._v("确认提交")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("预览红包信息")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "review-info"
  }, [_c('span', {
    staticClass: "info-title"
  }, [_vm._v("红包有效期")]), _vm._v(" "), _c('span', {
    staticClass: "info-desc"
  }, [_c('span', {
    staticClass: "highlight ml-0"
  }, [_vm._v("14")]), _vm._v("天内使用")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-desc"
  }, [_c('div', {
    staticClass: "remark ml-0 mt-20"
  }, [_vm._v("备注：红包费用由商户承担")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-desc"
  }, [_c('div', {
    staticClass: "remark ml-0 mt-20"
  }, [_vm._v("备注：红包费用由商户承担")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e24ab6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reviewpacket/reviewpacket.vue
// module id = 805
// module chunks = 1